import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { simulationPresetApiToSimulationPresetEntity, simulationPresetEntityToApi } from '../../entities/SimulationPreset/converters';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class SimulationPresetClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createSimulationPresetImpl", void 0);
    _defineProperty(this, "getSimulationPresetImpl", void 0);
    _defineProperty(this, "updateSimulationPresetImpl", void 0);
    _defineProperty(this, "deleteSimulationPresetImpl", void 0);
    _defineProperty(this, "querySimulationPresetsImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'SimulationPresetClient';
  }
  async createSimulationPreset(simulationPreset) {
    try {
      const request = this.createSimulationPresetImpl({
        simulationPreset: simulationPreset
      });
      for (var _len = arguments.length, extraParam = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        extraParam[_key - 1] = arguments[_key];
      }
      const {
        simulationPreset: createdSimulationPreset
      } = await this.request(request, ...extraParam);
      if (!createdSimulationPreset) {
        throw new Error('Invalid simulation preset response');
      }
      return this.convertToEntity(createdSimulationPreset);
    } catch (error) {
      this.logError('createSimulationPreset', 'Failed to create simulation preset', {
        simulationPreset
      }, error);
      throw error;
    }
  }
  async getSimulationPreset(simulationPresetId) {
    try {
      for (var _len2 = arguments.length, extraParam = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        extraParam[_key2 - 1] = arguments[_key2];
      }
      const {
        simulationPreset
      } = await this.request(this.getSimulationPresetImpl({
        simulationPresetId
      }), ...extraParam);
      if (!simulationPreset) {
        throw new Error('Simulation preset not found');
      }
      return this.convertToEntity(simulationPreset);
    } catch (error) {
      this.logError('getSimulationPreset', 'Failed to get simulation preset', {
        simulationPresetId
      }, error);
      throw error;
    }
  }
  async updateSimulationPreset(simulationPreset) {
    try {
      const request = this.updateSimulationPresetImpl({
        simulationPreset: simulationPresetEntityToApi(simulationPreset)
      });
      for (var _len3 = arguments.length, extraParam = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        extraParam[_key3 - 1] = arguments[_key3];
      }
      const {
        simulationPreset: updatedSimulationPreset
      } = await this.request(request, ...extraParam);
      if (!updatedSimulationPreset) {
        throw new Error('Invalid simulation preset response');
      }
      return this.convertToEntity(updatedSimulationPreset);
    } catch (error) {
      this.logError('updateSimulationPreset', 'Failed to update simulation preset', {
        simulationPreset
      }, error);
      throw error;
    }
  }
  async deleteSimulationPreset(simulationPresetId) {
    try {
      for (var _len4 = arguments.length, extraParam = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        extraParam[_key4 - 1] = arguments[_key4];
      }
      await this.request(this.deleteSimulationPresetImpl({
        simulationPresetId
      }), ...extraParam);
    } catch (error) {
      this.logError('deleteSimulationPreset', 'Failed to delete simulation preset', {
        simulationPresetId
      }, error);
      throw error;
    }
  }
  async querySimulationPresets(query) {
    try {
      for (var _len5 = arguments.length, extraParam = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        extraParam[_key5 - 1] = arguments[_key5];
      }
      const {
        simulationPresets,
        pagingMetadata
      } = await this.request(this.querySimulationPresetsImpl({
        query
      }), ...extraParam);
      if (!simulationPresets) {
        throw new Error('Received invalid simulation presets');
      }
      return {
        items: simulationPresets.map(this.convertToEntity),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('querySimulationPresets', 'Failed to query simulation presets', {
        query
      }, error);
      throw error;
    }
  }
  convertToEntity(simulationPresetApi) {
    return simulationPresetApiToSimulationPresetEntity(simulationPresetApi);
  }
}
//# sourceMappingURL=SimulationPresetClientBase.js.map